/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const ButtonPrimaryBorderWidthDefault = '0px'
export const ButtonPrimaryBorderWidthHovered = '0px'
export const ButtonPrimaryBorderWidthPressed = '0px'
export const ButtonPrimaryBorderWidthDisabled = '0px'
export const ButtonPrimaryColorPositiveDefaultBackground = '#ED9341'
export const ButtonPrimaryColorPositiveDefaultOnBackground = '#ffffff'
export const ButtonPrimaryColorPositiveDefaultOutline = '#ffffff00'
export const ButtonPrimaryColorPositiveHoveredBackground = '#e28d3f'
export const ButtonPrimaryColorPositiveHoveredOnBackground = '#ffffff'
export const ButtonPrimaryColorPositiveHoveredOutline = '#ffffff00'
export const ButtonPrimaryColorPositivePressedBackground = '#d8873d'
export const ButtonPrimaryColorPositivePressedOnBackground = '#ffffff'
export const ButtonPrimaryColorPositivePressedOutline = '#ffffff00'
export const ButtonPrimaryColorPositiveDisabledBackground = '#0000000a'
export const ButtonPrimaryColorPositiveDisabledOnBackground = '#00000061'
export const ButtonPrimaryColorPositiveDisabledOutline = '#ffffff00'
export const ButtonPrimaryColorDestructiveDefaultBackground = '#f4511e'
export const ButtonPrimaryColorDestructiveDefaultOnBackground = '#ffffff'
export const ButtonPrimaryColorDestructiveDefaultOutline = '#ffffff00'
export const ButtonPrimaryColorDestructiveHoveredBackground = '#e94e1d'
export const ButtonPrimaryColorDestructiveHoveredOnBackground = '#ffffff'
export const ButtonPrimaryColorDestructiveHoveredOutline = '#ffffff00'
export const ButtonPrimaryColorDestructivePressedBackground = '#df4b1d'
export const ButtonPrimaryColorDestructivePressedOnBackground = '#ffffff'
export const ButtonPrimaryColorDestructivePressedOutline = '#ffffff00'
export const ButtonPrimaryColorDestructiveDisabledBackground = '#0000000a'
export const ButtonPrimaryColorDestructiveDisabledOnBackground = '#00000061'
export const ButtonPrimaryColorDestructiveDisabledOutline = '#ffffff00'
export const ButtonPrimaryColorWarningDefaultBackground = '#fb8c00'
export const ButtonPrimaryColorWarningDefaultOnBackground = '#ffffff'
export const ButtonPrimaryColorWarningDefaultOutline = '#ffffff00'
export const ButtonPrimaryColorWarningHoveredBackground = '#f08604'
export const ButtonPrimaryColorWarningHoveredOnBackground = '#ffffff'
export const ButtonPrimaryColorWarningHoveredOutline = '#ffffff00'
export const ButtonPrimaryColorWarningPressedBackground = '#e58007'
export const ButtonPrimaryColorWarningPressedOnBackground = '#ffffff'
export const ButtonPrimaryColorWarningPressedOutline = '#ffffff00'
export const ButtonPrimaryColorWarningDisabledBackground = '#0000000a'
export const ButtonPrimaryColorWarningDisabledOnBackground = '#00000061'
export const ButtonPrimaryColorWarningDisabledOutline = '#ffffff00'
